import { TextField } from "@mui/material";

import styled from "styled-components";

export const TextFieldLib = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      border-radius: 8px;
      border: 1px solid rgba(235, 194, 142, 0.2);
      background-color: #513a28;
      padding-right: 0;
      transition: all 0.2s ease;
      color: #f7ede6;
      font-family: "Raleway", sans-serif;
      font-size: 0.9rem;

      &:hover {
        border-color: rgba(235, 194, 142, 0.4);
      }

      &.Mui-focused {
        border-color: rgba(235, 194, 142, 0.5);
      }

      &.Mui-disabled {
        background-color: rgba(81, 58, 40, 0.4);
        opacity: 0.5;
      }

      .MuiOutlinedInput-notchedOutline {
        border: none;
      }

      input {
        color: #f7ede6;
        font-family: "Raleway", sans-serif;
        font-size: 0.9rem;

        &::placeholder {
          color: rgba(185, 160, 137, 0.5);
          opacity: 1;
        }
      }
    }
  }
`;
